export default __webpack_public_path__ + "static/media/forget-password.8d54d5be.png";